import head from './head'
import route from './route'
import tabs from './tabs'

export default {
  tabs,
  route,
  head
}
